const GITLAB_HABITICA_WEBHOOK = {
    name: 'Gitlab Webhook pour Habitica',
    description:
        "Un micro service que l'on branche sur les webhooks de Gitlab afin de générer et/ou de terminer des tâches dans Habitica.",
    technologies: ['Javascript', 'Koa'],
    firstReleaseDate: '26/05/2018'
};

export default GITLAB_HABITICA_WEBHOOK;
